export default [
  {
    path: '/apps/produtos/list',
    name: 'apps-produtos-list',
    component: () => import('@/views/app/produtos/list/Index.vue'),
    meta: {
      pageTitle: 'Produtos',
    },
  },
  {
    path: '/apps/produto/edit/:id',
    name: 'apps-produto-edit',
    component: () => import('@/views/app/produtos/edit/EditProduto.vue'),
    meta: {
      pageTitle: 'Editar Produto',
      // breadcrumb: [
      //     {
      //         text: 'Produtos',
      //         to: '/apps/produtos/list',
      //     },
      //     {
      //         text: 'Editar Produto',
      //         active: true,
      //     },
      // ],
    },

  },
  {
    path: '/produto/novo',
    name: 'produto-novo',
    component: () => import('@/views/app/produtos/create/NewProduto.vue'),
    meta: {
      pageTitle: 'Novo Produto',
      breadcrumb: [
        {
          text: 'Produtos',
          to: '/apps/produtos/list',
        },
        {
          text: 'Novo Produto',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Produtos',
    },
  },
];
